/**
 * Chart-header currency picker. Sits in the top-right of TvAdvancedChart
 * and lets the trader see prices in USD, INR, EUR etc.
 */
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const OPTIONS = [
  { code: "USD", flag: "🇺🇸" }, { code: "INR", flag: "🇮🇳" },
  { code: "EUR", flag: "🇪🇺" }, { code: "GBP", flag: "🇬🇧" },
  { code: "AED", flag: "🇦🇪" }, { code: "SGD", flag: "🇸🇬" },
  { code: "JPY", flag: "🇯🇵" }, { code: "AUD", flag: "🇦🇺" },
];

export function ChartCurrencyPicker({ value, onChange }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-7 w-[92px] bg-background/80 backdrop-blur border border-border text-xs font-semibold rounded-md" data-testid="chart-currency-picker">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="z-[200]">
        {OPTIONS.map((o) => (
          <SelectItem key={o.code} value={o.code} data-testid={`chart-ccy-${o.code}`}>
            <span className="mr-2">{o.flag}</span>{o.code}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
